import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { TTicket } from '@/types/ticket';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_GetAll_Ticket = {
  location_id?: Id;
};

export type ApiResponse_GetAll_Ticket = Array<TTicket>;

const METHOD = 'GET';
const ENDPOINT = 'ticket/all';
export const QUERY_KEY = (params?: ApiRequest_GetAll_Ticket) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetAllTickets = (params: ApiRequest_GetAll_Ticket, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: !!params.location_id && enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      try {
        const data = await handleApiCall<ApiResponse_GetAll_Ticket, ApiRequest_GetAll_Ticket>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {}),
          params
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch tickets.', { variant: 'error' });

        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
